import { NavigationContainer } from '@react-navigation/native';
import { useFonts } from 'expo-font';
import { StatusBar } from 'expo-status-bar';
import { ActivityIndicator, I18nManager, Platform, StyleSheet, Text, View } from 'react-native';
import MainNavigate from './src/navigation/mainnavigate';

 import {LogBox} from "react-native";
import { Provider } from 'react-redux';
import { applyMiddleware, combineReducers, legacy_createStore as createStore } from 'redux'
import thunk from 'redux-thunk';
import userLogin from "./src/store/reducers/userLogin"
import userProduct from "./src/store/reducers/userProduct"
import finalproduct from "./src/store/reducers/finalproduct"

import * as Linking from "expo-linking"

import messaging from '@react-native-firebase/messaging';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useEffect } from 'react';

// import {SSRProvider} from '@react-aria/ssr';
// import registerNNPushToken from 'native-notify';
// LogBox.ignoreLogs([
// "exported from 'deprecated-react-native-prop-types'.",
// ])
// LogBox.ignoreLogs([ 'In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.', ])
I18nManager.forceRTL(false);
I18nManager.allowRTL(false);

const prefix = Linking.createURL('/');


export default function App() {

  

if (Platform.OS=="android") {
  

  const requestUserPermission = async () => {
    const authStatus = await messaging().requestPermission();
    const enabled =
      authStatus === messaging.AuthorizationStatus.AUTHORIZED ||
      authStatus === messaging.AuthorizationStatus.PROVISIONAL;

    if (enabled) {
      console.log('Authorization status:', authStatus);
    }
  }

  useEffect(() => {
  
    if (requestUserPermission()) {
      messaging().getToken().then(token => {
        if (token) {
          AsyncStorage.setItem('expo_token', token).then(function () {
            console.log('token save in app.js');
          });
        }
      })
    } else {
      console.log("filed token stutus", authStatus);
    }


    // Check whether an initial notification is available
    messaging()
      .getInitialNotification()
      .then(async (remoteMessage) => {
        if (remoteMessage) {
          console.log(
            'Notification caused app to open from quit state:',
            remoteMessage.notification,
          );

        }

      });

    // Assume a message-notification contains a "type" property in the data payload of the screen to open

    messaging().onNotificationOpenedApp(async (remoteMessage) => {
      console.log(
        'Notification caused app to open from background state:',
        remoteMessage.notification,
      );

    });


    // Register background handler
    messaging().setBackgroundMessageHandler(async remoteMessage => {
      console.log('Message handled in the background!', remoteMessage);
    });

    const unsubscribe = messaging().onMessage(async remoteMessage => {
      Alert.alert('A new FCM message arrived!', JSON.stringify(remoteMessage));
    });

    return unsubscribe;

  }, [])

}





//  cutunix://splash
  const linking = {
    prefixes: [prefix],
    config: {
      screens: {
        splash:'splash',
       
        },
      },
    };
  






  // registerNNPushToken(4178, 'kd9wWUrgEMrKcZVrQpJEf7');
  const [loaded] = useFonts({
    Montserrat: require('./assets/font/IRANSansMobile.ttf'),
    Montserrat1: require('./assets/font/IRANSansMobile1.ttf'),
    MontserratBold: require('./assets/font/IRANSansMobileBold.ttf'),
    MontserratBold1: require('./assets/font/IRANSansMobileBold1.ttf'),
    MontserratLight: require('./assets/font/IRANSansMobileLight.ttf'),
  });
  if (!loaded) {
    return null;
  }



  const appReducer = combineReducers({
    userLogin,
    userProduct,
    finalproduct


  })



  const store = createStore(appReducer, applyMiddleware(thunk))





  return(
    
     <Provider store = { store } >
     

   
        <NavigationContainer
            linking={linking}
        >
          <StatusBar backgroundColor="white" />
          <MainNavigate />
        </NavigationContainer>
          
    </Provider >



  )



}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
